module.exports = __webpack_public_path__ + "img/banner2_3.9abf7d94.png";